// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1nWub","label":"CategoryService_label__txzG4","location":"CategoryService_location__2B7vH"};